import * as React from 'react'
import { Text, Inset, StackChildren, Colors } from '@doordash/design-language'
import { ErrorScreenImage } from './images'
import { ImageContainer } from './styles'
import { i18nKeys } from 'translationTypes'
import i18n from '../../../i18n'

export const ErrorScreen = () => (
  <Inset size={Inset.Sizes.Medium} isSquished>
    <StackChildren>
      <ImageContainer>
        <ErrorScreenImage />
      </ImageContainer>

      <Text
        textAlign={Text.TextAlignments.Center}
        styles={Text.Styles.Title2}
        weight={Text.Weights.Bold}
      >
        {i18n.t(i18nKeys.webview_error_heading)}
      </Text>

      <Text
        textAlign={Text.TextAlignments.Center}
        styles={Text.Styles.SectionSubtext}
        color={Colors.TextSecondary}
      >
        {i18n.t(i18nKeys.webview_error_description)}
      </Text>
    </StackChildren>
  </Inset>
)
